import { CircleUserRound, CreditCard, LockKeyhole, PenLine, type LucideIcon } from 'lucide-react';
import type { Brand, EnvInfo } from '../../api/types.ts';

export interface NavItem {
  to: string;
  label: string;
  /** The tab bar's narrower name. */
  short: string;
  icon: LucideIcon;
}

const ITEMS: NavItem[] = [
  { to: '/signature', label: 'Signature', short: 'Signature', icon: PenLine },
  { to: '/profile', label: 'Profile', short: 'Profile', icon: CircleUserRound },
  // Devices, shared emails and account deletion, as the large account pages group them.
  { to: '/privacy', label: 'Privacy & security', short: 'Privacy', icon: LockKeyhole },
  { to: '/subscription', label: 'Subscription', short: 'Plan', icon: CreditCard },
];

/**
 * The legacy rule: TypeApp in production shows neither the editor nor the
 * subscription page. Pages still on sample data show in development only.
 */
export function visibleItems(brand: Pick<Brand, 'id'>, env: EnvInfo['env']): NavItem[] {
  if (brand.id === 'BM' && env === 'production') {
    return ITEMS.filter((item) => item.to !== '/signature' && item.to !== '/subscription');
  }
  return ITEMS;
}

/**
 * Pages that are a working canvas rather than a page to read: the content
 * takes the sheet's whole width. The
 * signature editor lays out side by side only from 1040px of its own width
 * (Blue Stamp `BENCH_AT`), which a capped page column never reaches.
 */
export function isCanvasRoute(pathname: string): boolean {
  return pathname === '/' || pathname.startsWith('/signature');
}

/** How many sections the phone's tab bar holds before the rest go under "More". */
const TAB_SLOTS = 5;

/** The tab bar's split: everything when it fits, else the first four and a "More" menu. */
export function splitTabs(items: NavItem[]): { tabs: NavItem[]; more: NavItem[] } {
  if (items.length <= TAB_SLOTS) return { tabs: items, more: [] };
  return { tabs: items.slice(0, TAB_SLOTS - 1), more: items.slice(TAB_SLOTS - 1) };
}
